import { render, staticRenderFns } from "./package.vue?vue&type=template&id=2f0cd41a&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=2f0cd41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cd41a",
  null
  
)

export default component.exports